import CouponService from "@/services/couponService";
import { useQuery } from "@tanstack/react-query";

export default function useGetCoupon({ placeId }: { placeId: string | null }) {
  const couponService = new CouponService();

  return useQuery({
    enabled: !!placeId,
    queryKey: ["coupon", placeId],
    queryFn: () => couponService.getCoupon({ placeId: parseInt(placeId!) }),
    retry: 1,
  });
}
